import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "@mui/material";
import AdUnitsOutlinedIcon from "@mui/icons-material/AdUnitsOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ManIcon from "@mui/icons-material/Man";
import WomanIcon from "@mui/icons-material/Woman";
import StarIcon from "@mui/icons-material/Star";
import { useMutation } from "react-query";
import { useQuery } from "react-query";
import { api } from "../../../../api/Intercepter";
import { useEffect } from "react";
import { useSnackbar } from "notistack";

const sendMessages = async ({ data }) => {
  let response = await api.post("/messages/send-custom-message", {
    message: `حمل تطبيق راديو الغد عبر الرابط التالي:
    qsr.ac/alghad-app`,
    phoneNumber: data.phoneNumber,
  });

  return response?.data;
};

const CallsFormPhoneField = ({
  hasApp,
  register,
  setValue,
  gender,
  setGender,
  errors,
  phoneNumber,
  isStarred,
  setIsStarred,
  isExistUser,
  clientId,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const { mutateAsync, isSuccess } = useMutation((data: any) => {
    return sendMessages({ data });
  });

  // Get all labels to find the star label ID
  const { data: labelsData } = useQuery({
    queryKey: ["labels"],
    queryFn: async () => {
      const response = await api.get("/labels");
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  // Mutation to toggle client labels
  const { mutateAsync: toggleClientLabel } = useMutation({
    mutationFn: async ({
      clientId,
      labelId,
      action,
    }: {
      clientId: number;
      labelId: number;
      action: "add" | "remove";
    }) => {
      if (action === "add") {
        const response = await api.post("/client-labels", {
          clientId,
          labelId,
        });
        console.log("POST response:", response.data);
        return response.data;
      } else {
        const response = await api.delete(
          `/client-labels/${clientId}/${labelId}`
        );
        console.log("DELETE response:", response.data);
        return response.data;
      }
    },
    onSuccess: (data) => {
      console.log("Mutation successful:", data);
      // Update the star state immediately for UI feedback
      setIsStarred(!isStarred);
    },
    onError: (error) => {
      console.error("Mutation failed:", error);
    },
  });

  useEffect(() => {
    if (isSuccess) {
      enqueueSnackbar("تم ارسال الرسالة بنجاح", {
        variant: "success",
      });
    }
  }, [isSuccess]);

  const handleStarToggle = async () => {
    try {
      if (!labelsData?.array || labelsData.array.length === 0) {
        console.error("Labels data not loaded yet or empty");
        return;
      }

      if (!clientId) {
        console.error("Client ID not available");
        return;
      }

      // Use the first label from the array (as discussed earlier)
      const starLabel = labelsData.array[0];

      if (!starLabel) {
        console.error("No labels available");
        return;
      }

      const action = isStarred ? "remove" : "add";

      console.log(
        `${
          action === "add" ? "Adding" : "Removing"
        } star for client ${clientId}`
      );

      await toggleClientLabel({
        clientId: clientId,
        labelId: starLabel.id,
        action: action,
      });

      console.log("Star toggle completed successfully");
    } catch (error) {
      console.error("Error toggling star label:", error);
    }
  };

  const handlePhoneNumber = (value) => {
    let cleanedPhoneNumber = value.replace(/^(07|\+96407|96407)/, "+9647");
    let cleanedPhoneNumberTo964 = cleanedPhoneNumber.replace(
      /^(\+964|964)/,
      "+964"
    );

    return cleanedPhoneNumberTo964;
  };

  return (
    <>
      <Box className="calls-card-form-phone-field">
        <FormControl sx={{ width: "100%" }}>
          <TextField
            placeholder="رقم الموبايل"
            label="رقم الموبايل"
            size="medium"
            {...register("phone", {
              required: true,
            })}
            sx={{
              ".muirtl-nugxp0-MuiInputBase-root-MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
            error={!!errors[`phone`]}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AdUnitsOutlinedIcon />
                </InputAdornment>
              ),
            }}
            disabled
          />
        </FormControl>
        <Button
          disabled={hasApp}
          className="calls-card-form-send-app"
          startIcon={<SendOutlinedIcon />}
          sx={{ fontSize: "12px", padding: "17px 0px", borderRadius: "12px" }}
          onClick={() => {
            mutateAsync({
              phoneNumber: handlePhoneNumber(phoneNumber),
            });
          }}
        >
          {hasApp ? <Box>يمتلك تطبيق</Box> : <Box>ارسال رابط التطبيق</Box>}
        </Button>
      </Box>
      <Box className="calls-card-form-name-field">
        <FormControl sx={{ width: "100%", marginTop: "20px" }}>
          <TextField
            placeholder="الاسم"
            label="الاسم"
            size="medium"
            {...register("name", { required: true })}
            error={!!errors[`name`]}
            sx={{
              ".muirtl-nugxp0-MuiInputBase-root-MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonOutlineOutlinedIcon />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>

        {isExistUser && (
          <IconButton
            onClick={handleStarToggle}
            disabled={!labelsData?.array}
            sx={{
              height: "56px",
              width: "56px",
              marginTop: "20px",
              borderRadius: "12px",
              backgroundColor: isStarred ? "#FFD700" : "#F5F5F5",
              border: isStarred ? "2px solid #FFA500" : "2px solid #E0E0E0",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: isStarred ? "#FFC107" : "#EEEEEE",
                transform: "scale(1.05)",
              },
              "&:disabled": {
                opacity: 0.5,
              },
            }}
          >
            {isStarred ? (
              <StarIcon
                sx={{
                  color: "#FF8F00",
                  fontSize: "28px",
                }}
              />
            ) : (
              <StarIcon
                sx={{
                  color: "#757575",
                  fontSize: "28px",
                }}
              />
            )}
          </IconButton>
        )}

        <ToggleButtonGroup
          exclusive
          className="calls-card-form-gender"
          sx={{
            border: !!errors[`gender`] && "1px solid red",
            borderRadius: "12px",
            marginTop: "20px",
          }}
          value={gender}
        >
          <ToggleButton
            sx={{
              width: "100%",
              borderRadius: "12px",
              padding: "15px 0",
            }}
            {...register("gender", { required: true })}
            className={`${
              gender === "male" ? "gov-shortcut-btn-active" : "gender-btn"
            }`}
            value={"male"}
            onClick={() => {
              setGender("male");
              setValue("gender", "male");
            }}
          >
            <ManIcon /> ذكر
          </ToggleButton>
          <ToggleButton
            sx={{
              width: "100%",
              borderRadius: "12px",
              padding: "15px 0",
            }}
            className={`${
              gender === "female" ? "gov-shortcut-btn-active" : "gender-btn"
            }`}
            value={"female"}
            onClick={() => {
              setGender("female");
              setValue("gender", "female");
            }}
          >
            <WomanIcon /> انثى
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </>
  );
};

export default CallsFormPhoneField;
